export const reduxKey = '@@POPOVERS';
export const actionPrefix = '@@POPOVERS';
